<mat-dialog-content>
  <h1 class="mb-2">{{ 'dialogs.end.well_done' | translate }}</h1>
  <gandalf-achievements [isInDialog]="true"></gandalf-achievements>
  <h2 class="mb-1">
    {{ 'dialogs.end.badges' | translate:{badge: ('levels.' + userService.userLevel() + '.achievement_badge' | translate)} }}
  </h2>
  <p class="strong">
    {{ 'levels.' + userService.userLevel() + '.achievement_badge_description' | translate }}
  </p>
  <hr class="my-2"/>
  <p [innerHtml]="('levels.' + userService.userLevel() + '.learning_text') | translate"></p>

  @if (showMoreInfo) {
    <p><em>{{ ('levels.' + userService.userLevel() + '.usecase_example') | translate }}</em></p>
    <hr class="my-2"/>
    <div class="scoreboard__scores">
      <div class="scoreboard__scores--attempts">
        <h4 class="mb-1">{{ 'dialogs.end.prompts' | translate }}</h4>
        <p class="eonscreen">{{ this.userService.userAttempts() }}</p>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <eon-ui-button (click)="startNextLevel()"
                 [disabled]="isStartingNextLevel()"
                 [text]="'buttons.next_level' | translate:{ level: nextLevelButtonLevel() }" rank="primary"
                 scheme="{{eonUiScheme}}"></eon-ui-button>
</mat-dialog-actions>
